import dynaForms from '@elab/core/utils/dynaForms';

const getTypes = storeName => ({
    ...dynaForms.getTypes(storeName),
    SET_CARD_INFO: `${storeName}.SET_CARD_INFO`,
    SET_GIFT_CARDS: `${storeName}.SET_GIFT_CARDS`,
    SET_PROPERTIES: `${storeName}.SET_PROPERTIES`,
    DELETE_ITEM: `${storeName}.DELETE_ITEM`,
    SET_ERRORS_DETAILS: `${storeName}.SET_ERRORS_DETAILS`,
    TOGGLE_FIELD_VALUE: `${storeName}.TOGGLE_FIELD_VALUE`,
    UPDATE_GIFT_CARD_AMOUNT: `${storeName}.UPDATE_GIFT_CARD_AMOUNT`,
    SET_CARDS_WITH_ERROR: `${storeName}.SET_CARDS_WITH_ERROR`,
    SET_VALIDATION_PARAMS: `${storeName}.SET_VALIDATION_PARAMS`,
    SET_GIFT_CARD_CODE_TO_BE_DELETED: `${storeName}.SET_GIFT_CARD_CODE_TO_BE_DELETED`,
    ASK_REMOVAL_CONFIRMATION: `${storeName}.ASK_REMOVAL_CONFIRMATION`,
    GET_GIFT_CARD_TYPE: `${storeName}.GET_GIFT_CARD_TYPE`,
    SET_GIFT_CARD_TYPE: `${storeName}.SET_GIFT_CARD_TYPE`,
    FOCUS_FIELD: `${storeName}.FOCUS_FIELD`,
    SET_IS_BALANCE_CHECK: `${storeName}.SET_IS_BALANCE_CHECK`,
});

export default getTypes;
